export default "__VITE_ASSET__Bsn20MYJ__"